import { render, staticRenderFns } from "./4_InterdictionAccueilPublic.vue?vue&type=template&id=5044d4de&scoped=true&"
import script from "./4_InterdictionAccueilPublic.vue?vue&type=script&lang=js&"
export * from "./4_InterdictionAccueilPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5044d4de",
  null
  
)

export default component.exports